import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  draft: {
    id: 'd+mH7Z',
    defaultMessage: 'Draft',
    description: 'Draft status for transfer order',
  },
  open: {
    id: 'Av1HOu',
    defaultMessage: 'Open',
    description: 'Open status for transfer order',
  },
  receiving: {
    id: 'T4Pf2a',
    defaultMessage: 'Receiving',
    description: 'Receiving status for transfer order',
  },
  received: {
    id: '+NVKts',
    defaultMessage: 'Received',
    description: 'Received status for transfer order',
  },
  closed: {
    id: 'PMuYTK',
    defaultMessage: 'Closed',
    description: 'Closed status for transfer order',
  },
  cancelled: {
    id: 'CrO2a4',
    defaultMessage: 'Cancelled',
    description: 'Cancelled status for transfer order',
  },
});
